export const servicesData = [
    {
        id: 1,
        title: "Data <br /> Analyst",
        modalTitle: "Data Analysis",
        modalDescription: "Transforming raw data into meaningful insights for informed decision-making.",
        modalList: [
            "Data Cleaning & Preprocessing",
            "SQL Querying & Advanced Reporting",
            "Exploratory Data Analysis (EDA)",
            "Data Visualization",
            "Business Intelligence & KPI Tracking",
        ],
    },

    {
        id: 2,
        title: "Data <br /> Engineer",
        modalTitle: "Data Engineering",
        modalDescription: "Building scalable, efficient, and reliable data systems tailored for business success.",
        modalList: [
            "ETL Pipeline Design & Optimization",
            "Data Integration & Consistency",
            "Database Architecture & Management",
            "Cloud Data Solutions (AWS, GCP, Azure)",
            "Web Scraping & Data Extraction",
        ],
    },

    {
        id: 3,
        title: "Data <br /> Scientist",
        modalTitle: "Data Science",
        modalDescription: "Developing intelligent solutions with machine learning, deep learning, and generative AI.",
        modalList: [
            "Predictive & Classification Modeling",
            "Deep Learning & Neural Networks",
            "Natural Language Processing (NLP)",
            "Large Language Models (LLMs) & Generative AI",
            "MLOps & Scalable Model Deployment",
        ],
    }
];
